export default "https://cdn-static.gokick.com/assets/5d59d840aa8978759fe32f9d0593dfb9088da5d0/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";